import FixaStatus from "@coworker/apprestructured/src/shared/wrappers/FixaStatus/FixaStatus";
import styles from "./SafetyAlarm.module.css";
import { useTranslation } from "@coworker/locales";

type SafetyAlarmProps = {
  dim?: boolean | undefined;
};

function SafetyAlarm({ dim = false }: SafetyAlarmProps) {
  const { t } = useTranslation();

  return (
    <FixaStatus
      data-testid={"safety-alarm"}
      variant={dim ? "indeterminate" : "negative"}
      label={t("safetyAlarmString")}
      small
      className={styles["root"]}
    />
  );
}

export default SafetyAlarm;
